import apiClient from '../index';

export const spPackageApi = {
  // The backend expects POST for listing packages (accepts filters in the body).
  // Use POST with an empty payload when no filters are needed.
  getPackages: (payload = {}) => apiClient.post('/service-provider/packages', payload),
  getPackage: (id) => apiClient.get(`/service-provider/packages/${id}`),
  createPackage: (data) => apiClient.post('/service-provider/packages', data),
  updatePackage: (id, data) => apiClient.put(`/service-provider/packages/${id}`, data),
  deletePackage: (id) => apiClient.delete(`/service-provider/packages/${id}`),
};

export default spPackageApi;
